module.exports = __webpack_public_path__ + "static/img/active6.aa49cdec.png";